import {
  Component,
  OnInit,
  ChangeDetectorRef,
  OnDestroy,
  EmbeddedViewRef,
  ViewChild,
} from '@angular/core';
import { UserInfo } from '../../../../shared/objects/auth/userinfo';
import { CpModule } from '../../../../shared/objects/auth/cpModule';
import { AuthService } from '../../../../core/services/auth.service';
import { Subscription } from 'rxjs';
import { SystemSettingsService } from '../services/system.settings.service';
import { PortalSetting } from '../../../../shared/objects/systemSettings/portal-setting';
import { PortalSettingEnum } from '../../../../shared/enums/portal-setting-type.enum';
import {
  MatSnackBar as MatSnackBar,
  MatSnackBarRef as MatSnackBarRef,
} from '@angular/material/snack-bar';
import { UserRole } from '../../../../shared/objects/auth/userRole';
import { OrderService } from '../../order/shared/order.service';
import { OrderFilter } from '../../../../shared/objects/order/orderFilter';
import { first, map } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
import { Constants } from '../../../../shared/const/constants';
import moment from 'moment';
import { Module } from '../../../../shared/objects/auth/module';
import { CarrierService } from '../services/carrier.service';
import { CarrierCertificate } from '../../../../shared/objects/carrier/carrierCertificate';
import { ModuleService } from '../../admin/shared/module.service';
@Component({
  selector: 'app-root',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  standalone: false,
})
export class DashboardComponent implements OnInit, OnDestroy {
  @ViewChild('snackBarTemplate') snackBarTemplate;
  snackBarRef: MatSnackBarRef<EmbeddedViewRef<any>>;
  mainAvailableModules: CpModule[];
  secondaryAvailableModules: CpModule[];
  availableModules: CpModule[];
  openIncidents: number = 0;
  subs: Subscription[] = [];
  portalSetting = new PortalSetting();
  warningMessage = '';
  ordersBaseUrl = '/secure/order-list/';
  orderFilter: OrderFilter = new OrderFilter();
  orders: any;
  currentUserRole;
  UserRole = UserRole;
  userHasAccessOrders = false;
  carrierCertificates: CarrierCertificate[] = [];
  carrierId;

  constructor(
    private authService: AuthService,
    private snackBar: MatSnackBar,
    private systemSettingsService: SystemSettingsService,
    private orderService: OrderService,
    private cdr: ChangeDetectorRef,
    private spinner: NgxSpinnerService,
    private carrierService: CarrierService,
    private moduleService: ModuleService,
  ) {}
  get AvailableModules() {
    return this.authService.getStoredUserInfo()
      ? this.moduleService.getAvailableModules()
      : [];
  }
  ngOnInit(): void {
    this.orderFilter = {
      actionOrders: 1,
      shortFilter: null,
      startDate: null,
      statuses: [],
      untilDate: null,
      isDashboardOrder: true,
    };

    const currentCarrierUsername = this.authService.getStoredUserInfo();
    if (
      !currentCarrierUsername ||
      currentCarrierUsername.preferred_username === ''
    ) {
      return;
    }

    this.subs.push(
      this.systemSettingsService
        .getPortalSettings()
        .subscribe(portalSettings => {
          this.portalSetting = portalSettings.find(
            setting => setting.type === PortalSettingEnum.String,
          );

          this.currentUserRole = this.authService.getUserRole();
          const userPermissions = this.authService.getUserFeatureClaims();

          this.userHasAccessOrders = userPermissions.includes(Module.Orders);

          if (
            this.AvailableModules.length > 0 &&
            this.currentUserRole !== UserRole.PortalAdmin &&
            this.currentUserRole !== UserRole.BusinessAdmin
          ) {
            this.carrierService
              .getCarrierByUsername(currentCarrierUsername.preferred_username)
              .then(res => {
                this.carrierId = res.carrierId;
              });

            this.spinner.show();
            this.subs.push(
              this.carrierService
                .getCarrierCertificates(true)
                .subscribe(response => {
                  this.carrierCertificates = response;
                  this.cdr.markForCheck();
                  this.spinner.hide();
                }),
            );
          }

          if (this.userHasAccessOrders) {
            this.spinner.show();
            this.subs.push(
              this.orderService
                .getFilteredOrders(this.orderFilter)
                .subscribe(orders => {
                  this.orders = orders;
                  this.cdr.markForCheck();
                  this.spinner.hide();
                }),
            );
          }

          if (this.portalSetting) {
            const userRoleIncluded =
              this.currentUserRole >= UserRole.CarrierAdmin &&
              this.currentUserRole <= this.portalSetting.userRole &&
              this.portalSetting.userRole % 2 === 1;

            const showWarningMessage =
              this.portalSetting &&
              (this.portalSetting.userRole === this.currentUserRole ||
                userRoleIncluded);

            if (showWarningMessage) {
              this.warningMessage = this.portalSetting.message;
              this.snackBarRef = this.snackBar.openFromTemplate(
                this.snackBarTemplate,
                {
                  verticalPosition: 'bottom',
                  panelClass: 'portal-warning',
                },
              );
            }
          }
        }),
    );
  }

  ngOnDestroy(): void {
    if (this.snackBarRef) {
      this.snackBarRef.dismiss();
    }
    this.subs.forEach(sub => sub.unsubscribe());
  }

  get getUserInfo(): UserInfo {
    return this.authService.getStoredUserInfo();
  }
}
